import type { AppParams, ExtendedAppParams } from "@/types/scheduling";
import { getQuizParams } from "@/utils/quiz";
import { getURLParams } from "@/utils/url";
import type { AppointmentData, QuizAnswers } from "shared/types";

export const getParams = (): ExtendedAppParams => {
  const quizParams = getQuizParams();
  const urlParams = getURLParams();
  let allUrlParams = true;
  let allQuizParams = true;

  // Helper function to check param dominance
  const checkParamDominance = (urlParam: string | undefined, quizParam: string | undefined) => {
    if (urlParam) {
      allQuizParams = false;
    } else if (quizParam) {
      allUrlParams = false;
    } else {
      allUrlParams = false;
      allQuizParams = false;
    }
  };

  // Check dominance for specified params
  checkParamDominance(urlParams.nutrition_area, quizParams.nutrition_area);
  checkParamDominance(urlParams.state, quizParams.state);
  checkParamDominance(urlParams.payment_method, quizParams.payment_method);
  checkParamDominance(urlParams.lead_name, quizParams.lead_name);
  checkParamDominance(urlParams.lead_phone_number, quizParams.lead_phone_number);

  // Check insurance_provider if payment_method is "insurance"
  if (urlParams.payment_method === "insurance" || quizParams.payment_method === "insurance") {
    checkParamDominance(urlParams.insurance_provider, quizParams.insurance_provider);
  }
  // prioritize URL params over quiz params
  let results: AppParams = {
    state: urlParams.state || quizParams.state || "",
    nutrition_area: urlParams.nutrition_area || quizParams.nutrition_area || "",
    expertise: urlParams.expertise || quizParams.expertise || "",
    payment_method: urlParams.payment_method || quizParams.payment_method || undefined,
    insurance_provider: urlParams.insurance_provider || quizParams.insurance_provider || undefined,
    insurance_provider_other: urlParams.insurance_provider_other || quizParams.insurance_provider_other || undefined,
    lead_name: urlParams.lead_name || quizParams.lead_name || undefined,
    lead_email: urlParams.lead_email || quizParams.lead_email || undefined,
    lead_phone_number: urlParams.lead_phone_number || quizParams.lead_phone_number || undefined,
    communication_style: urlParams.communication_style || quizParams.communication_style || undefined,
    provider_id: urlParams.provider_id || undefined,
    plan_id: urlParams.plan_id || undefined,
    diabetes_insulin_pump: quizParams?.diabetes_insulin_pump || undefined,
    op_mode: urlParams.op_mode || undefined,
  };

  return {
    ...results,
    used_only_url_params: allUrlParams,
    used_only_quiz_params: allQuizParams,
  };
};

export const shouldModifyHealthieProfile = (quizAnswers: QuizAnswers | null, apptData: AppointmentData): boolean => {
  const result = quizAnswers?.payment_method === "insurance" || apptData?.payment_method === "insurance";
  return result;
};
